document.addEventListener('DOMContentLoaded', (event) => {

    /*
    **====================================================================================
    **			FUNKCJE GŁÓWNE
    **====================================================================================
    **/

    function prepend(newElem, elem) {
        elem.outerHTML = newElem + elem.outerHTML;
    }
    function append(newElem, elem) {
        elem.outerHTML = elem.outerHTML + newElem;
    }


    /*
    **====================================================================================
    **			FORMULARZ CF 7
    **====================================================================================
    **/
    //zmienne
    const mrfClass = "cf7-mod", mrfCheck = "is-check";
    //funkcje
    function resetCF7FormFields() {
        document.querySelectorAll(".c-cf7 input").forEach(function(elem, index) {
            if (["", "email", "tel", "text"].includes(elem.getAttribute("type"))) elem.value = "";
        });
        document.querySelectorAll(".c-cf7 textarea").forEach(function(elem, index) {
            elem.value = "";
        });
        document.querySelectorAll(".cf7-mod__checkbox").forEach(function(elem, index) {
            elem.classList.remove(mrfCheck);
            elem.nextSibling.checked = false;
        });
		document.querySelectorAll(".cf7-mod__radio").forEach(function(elem, index) {
            elem.classList.remove(mrfCheck);
            elem.nextSibling.checked = false;
        });
		for (const cf7Field of document.querySelectorAll(".c-cf7 .wpcf7-form-control")) {
            cf7Field.parentElement.classList.remove("wpcf7-form-control-wrap--active");
        }
    }
    //dodawanie odpowiednich elementów modyfikacji
    document.querySelectorAll(".c-cf7 .wpcf7-checkbox").forEach(function (elem, index) {
        elem.classList.add(mrfClass);
        elem.querySelectorAll("input").forEach(function (input, index) {
            if (input.getAttribute("type") == "checkbox") {
                let mrfSetCheck = "";
                if (input.checked) mrfSetCheck = " "+mrfCheck;
                let prependElement = input;
                if (input.parentNode.tagName == "LABEL") prependElement = input.parentNode;
                prepend("<span class='cf7-mod__checkbox"+mrfSetCheck+"'></span>", prependElement);
            }
        });
    });
    document.querySelectorAll(".c-cf7 .wpcf7-radio").forEach(function (elem, index) {
        elem.classList.add(mrfClass);
        elem.querySelectorAll("input").forEach(function (input, index) {
            if (input.getAttribute("type") == "radio") {
                let mrfSetCheck = "";
                if (input.checked) mrfSetCheck = " "+mrfCheck;
                let prependElement = input;
                if (input.parentNode.tagName == "LABEL") prependElement = input.parentNode;
                prepend("<span class='cf7-mod__radio"+mrfSetCheck+"'></span>", prependElement);
            }
        });
    });
    //zdarzenie click na elementach dodanych
    //checkbox
    for (const elemCheckboxFieldWrap of document.querySelectorAll(".cf7-mod .cf7-mod__checkbox")) {
        elemCheckboxFieldWrap.addEventListener('click', function(event) {
            elemCheckboxFieldWrap.classList.toggle(mrfCheck);
            let elemcCheckbox = elemCheckboxFieldWrap.nextSibling;
            if (elemcCheckbox.tagName == "LABEL") elemcCheckbox = elemCheckboxFieldWrap.parentNode.querySelector("input");
            if (elemCheckboxFieldWrap.classList.contains(mrfCheck)) {
				elemcCheckbox.checked = true; elemcCheckbox.classList.add("tru");
			}
            else {
                elemcCheckbox.checked = false; elemcCheckbox.classList.add("fals");
            }
        });
    }
    //checkbox etykietka - wykrycie zmiany pola input
    for (const elemCheckboxField of document.querySelectorAll(".cf7-mod.wpcf7-checkbox .wpcf7-list-item input")) {
        elemCheckboxField.addEventListener('change', function(event) {
            let checkModField = elemCheckboxField.parentElement.previousSibling;
            if (checkModField.classList.contains("cf7-mod__checkbox")) {
                if (elemCheckboxField.checked) checkModField.classList.add(mrfCheck);
                else checkModField.classList.remove(mrfCheck);
            }
        });
    }
    //radio
    for (const elemRadioFieldWrap of document.querySelectorAll(".cf7-mod .cf7-mod__radio")) {
        elemRadioFieldWrap.addEventListener('click', function(event) {
            let parentMrfMod = elemRadioFieldWrap.parentElement.parentElement;
            if (parentMrfMod.classList.contains("cf7-mod")) {
                for (const elemcRadios of parentMrfMod.querySelectorAll(".cf7-mod__radio")) {
                    elemcRadios.classList.remove(mrfCheck);
                }
            }
            elemRadioFieldWrap.classList.toggle(mrfCheck);
            let elemcRadio = elemRadioFieldWrap.nextSibling;
            if (elemcRadio.tagName == "LABEL") elemcRadio = elemRadioFieldWrap.parentNode.querySelector("input");
            if (elemRadioFieldWrap.classList.contains(mrfCheck)) { elemcRadio.checked = true; elemcRadio.classList.add("tru"); }
            else {
                elemcRadio.checked = false; elemcRadio.classList.add("fals");
            }
        });
    }
    //radio etykietka - wykrycie zmiany pola input
    for (const elemRadioField of document.querySelectorAll(".cf7-mod.wpcf7-radio .wpcf7-list-item input")) {
        elemRadioField.addEventListener('change', function(event) {
            //usunięcie wszystkich zaznaczeń
            let parentMrfMod = elemRadioField.parentElement.parentElement.parentElement;
            if (parentMrfMod.classList.contains("cf7-mod")) {
                for (const elemRadios of parentMrfMod.querySelectorAll(".cf7-mod__radio")) {
                    elemRadios.classList.remove(mrfCheck);
                }
            }
            let radioModField = elemRadioField.parentElement.previousSibling;
            if (radioModField.classList.contains("cf7-mod__radio")) {
                if (elemRadioField.checked) radioModField.classList.add(mrfCheck);
                else radioModField.classList.remove(mrfCheck);
            }
        });
    }
    //etykietki pól standardowych
    for (const cf7Field of document.querySelectorAll(".c-cf7 .wpcf7-form-control")) {
        let activeClass = "wpcf7-form-control-wrap--active";
        let elemParent = cf7Field.parentElement;
        cf7Field.addEventListener('input', function(event) {
            if (cf7Field.tagName == "INPUT" || cf7Field.tagName == "TEXTAREA") {
                if (cf7Field.value == "") elemParent.classList.remove(activeClass);
                else {
                    if (!elemParent.classList.contains(activeClass)) {
                        elemParent.classList.add(activeClass);
                    }
                }
            }
        });
        if (cf7Field.value != "") {
            if (!elemParent.classList.contains(activeClass)) {
                elemParent.classList.add(activeClass);
            }
        }
        cf7Field.addEventListener('click', function(event) {
            if (cf7Field.tagName == "INPUT" || cf7Field.tagName == "TEXTAREA") {
                document.querySelectorAll(".c-cf7 .wpcf7-form-control-wrap").forEach(function(elemControlWrap, index) {
                    let nextSibling = elemControlWrap.nextElementSibling;
                    if (nextSibling && nextSibling.classList.contains("wpcf7-field-label")) {
                        let elemField = elemControlWrap.querySelector(".wpcf7-form-control");
                        if (elemField.value == "" && (elemField.tagName == "INPUT" || elemField.tagName == "TEXTAREA")) {
                            elemControlWrap.classList.remove(activeClass);
                        }
                    }
                });
                if (!elemParent.classList.contains(activeClass)) {
                    elemParent.classList.add(activeClass);
                }
            }
        });
    }
    //symulacja clicka na submicie (przycisk obsługujący jest innym elementem, a właściwy submit jest ukryty)
    /*const iptcfSubmit = document.querySelector(".c-cf7__row--submit .ipt-btn--submit");
    if (iptcfSubmit != null) {
        iptcfSubmit.addEventListener("click", function(event) {
            iptcfSubmit.parentNode.querySelector(".wpcf7-submit").click();
        });
    }*/
    //symulacja clicka na resecie (j/w)
    const iptcfReset = document.querySelector(".c-cf7__row--submit .ipt-btn--reset");
    if (iptcfReset != null) {
        iptcfReset.addEventListener("click", function(event) {
            resetCF7FormFields();
        });
    }
    document.addEventListener('wpcf7mailsent', function (event) {
        resetCF7FormFields();
    }, false);

    //wybór pliku
    const iptcfFile = document.querySelector(".c-cf7__row--file .c-cf7__file-btn");
    if (iptcfFile != null) {
        iptcfFile.addEventListener("click", function(event) {
            iptcfFile.parentNode.parentNode.parentNode.querySelector(".c-cf7__file-field").click();
        });
    }
    const iptcfFileField = document.querySelector(".c-cf7__file-field");
    if (iptcfFileField != null) {
        iptcfFileField.addEventListener("change", function(event) {
            let thisValArray = iptcfFileField.value.split("\\");
            document.querySelector(".c-cf7__row--file .c-cf7__file-name").innerHTML = thisValArray[thisValArray.length - 1];
        });
    }

    //rodo - more
    const iptRodoElement = document.querySelector(".jsRodoElem .wpcf7-list-item-label");
    if (iptRodoElement != null) {
        let iptRodoElementVal = iptRodoElement.innerHTML;
        iptRodoElementVal = iptRodoElementVal.replace("%ws%", '<span class="cf7-rodo-more-btn jsRodoMoreBtn">Więcej &raquo;</span><span class="cf7-rodo-hide-text jsRodoMoreText">');
        iptRodoElementVal = iptRodoElementVal.replace("%we%", '</span>');
        iptRodoElement.innerHTML = iptRodoElementVal;

        const iptRodoMoreBtn = iptRodoElement.querySelector(".jsRodoMoreBtn");
        if (iptRodoMoreBtn != null) {
            iptRodoMoreBtn.addEventListener("click", function(event) {
                iptRodoMoreBtn.remove();
                iptRodoElement.querySelector(".jsRodoMoreText").classList.add("cf7-rodo-hide-text--is-show");
            });
        }
    }


    /*
    **====================================================================================
    **			SCROLL ANIM
    **====================================================================================
    **/
    let iptAnimElemArray = [];
    let iptAnimElemArrayCounter = 0;
    let iptAnimEventTimeout;
    let iptAnimClass = ".ipt-anim";
    let iptAnimShowClass = "ipt-anim--is-show";
    let iptAnimOffset = 150;
    let iptLazyClass = "ipt-anim--lazy";
    let iptLazyLoadClass = "ipt-lazy--load";

    document.querySelectorAll(iptAnimClass).forEach(function(elem, index) {
        iptAnimElemArray.push(elem);
    });

    function iptInView(onReload) {
        if (!iptAnimEventTimeout && iptAnimElemArrayCounter < iptAnimElemArray.length) {
            iptAnimEventTimeout = setTimeout(function () {
                iptAnimEventTimeout = null;
                iptAnim(onReload);
            }, 300);
        }
    }
    function iptAnim(onReload) {
        iptAnimElemArray.forEach(function(elemThis, index) {
            if (!elemThis.classList.contains(iptAnimShowClass)) {
                let elementOffsetFromTop = elemThis.getBoundingClientRect().top + window.scrollY;
                let elementOffsetFromBottom = elementOffsetFromTop + elemThis.offsetHeight;
                let viewportScrollTop = window.scrollY;
                let iptAnimOffsetCurrent = iptAnimOffset;
                if (screen.width <= 360) { iptAnimOffsetCurrent = 30; }
                let iptOffsetLazy = -10;
                if (elemThis.classList.contains("ipt-anim--slidebot")) {
                    iptAnimOffsetCurrent = -50;
                    if (screen.width <= 360) { iptAnimOffsetCurrent = -70; }
                    iptOffsetLazy = iptAnimOffsetCurrent - iptAnimOffset;
                }
                if (elemThis.classList.contains("ipt-anim--slidebot3d-tile")) {
                    iptAnimOffsetCurrent = -150;
                    if (screen.width <= 360) { iptAnimOffsetCurrent = -70; }
                    iptOffsetLazy = iptAnimOffsetCurrent - iptAnimOffset;
                }
                let viewportScrollBottom = viewportScrollTop + window.innerHeight - iptAnimOffsetCurrent; //window.innerHeight to wysokość fragmentu dokumentu widocznego w oknie przeglądarki
                let viewportScrollBottomLazy = viewportScrollTop + window.innerHeight - iptOffsetLazy;
                //Akcja Lazy rozpoczyna się wcześniej niż akcja Anim
                if (elementOffsetFromBottom > viewportScrollTop && elementOffsetFromTop < viewportScrollBottomLazy) {
                    if (elemThis.classList.contains(iptLazyClass) && !elemThis.classList.contains(iptLazyLoadClass)) {
                        if (elemThis.getAttribute("ipt-src") != null) {
                            elemThis.setAttribute("src", elemThis.getAttribute("ipt-src"));
                            elemThis.removeAttribute("ipt-src");
                            elemThis.classList.add(iptLazyLoadClass);
                        }
                        else {
                            elemThis.querySelectorAll(".ipt-lazy").forEach(function(elemLazy, index) {
                                if (elemLazy.getAttribute("ipt-src") != null && !elemLazy.classList.contains(iptLazyLoadClass)) {
                                    elemLazy.setAttribute("src", elemLazy.getAttribute("ipt-src"));
                                    elemLazy.removeAttribute("ipt-src");
                                    elemLazy.classList.add(iptLazyLoadClass);
                                }
                            });
                        }
                    }
                }
                /*
                elemThis.getBoundingClientRect().top -----> odległość górnej krawędzi elementu od górnej krawędzi przeglądarki - ta wartość zmniejsza się w miarę scrollowania w dół
                window.scrollY -----> aktualna pozycja scrolla
                window.innerHeight -----> wysokość okna widocznego na ekranie
                elemThis.offsetHeight -----> wysokość elementu
                elementOffsetFromTop -----> daje nam stałą pozycję górnej krawędzi elementu od góry strony (bo gdy pierwsza wartość maleje to druga rośnie)
                elementOffsetFromBottom -----> elementOffsetFromTop i do tego wartość wysokości elementu
                viewportScrollTop -----> przyjmuje wartość aktualnej pozycjo scrolla
                viewportScrollBottom -----> aktualna pozycja scrolla + wysokość okna widocznego na ekranie, czyli jeżeli jesteśmy na samej górze, to pierwsza zmienna będzie 0 a druga 0+wysokość okna

                elementOffsetFromBottom > viewportScrollTop ----->
                Gdy elementOffsetFromBottom <= viewportScrollTop to dolna krawędź elementu znika za górną krawędzią okna

                elementOffsetFromTop < viewportScrollBottom ----->
                gdy elementOffsetFromTop <= viewportScrollBottom to górna krawędź elementu zaczyna wychodzić zza dolnej krawędzi okna
                jednak animacja nie może się zaczynać w momencie jak górna krawędź elementu styka się z dolną krawdzią okna bo byśmy nie widzieli tej animacji
                więc elementOffsetFromTop musi pozostać dłużej większy od viewportScrollBottom - więc viewportScrollBottom musimy dodatkowo pomniejszyć o wartość zmienej iptAnimOffsetCurrent
                */
                if (elementOffsetFromBottom > viewportScrollTop && elementOffsetFromTop < viewportScrollBottom) {
                    iptAnimElemArrayCounter++;
                    if (!elemThis.classList.contains(iptAnimShowClass)) elemThis.classList.add(iptAnimShowClass);
                }
            }
        });
    }

    for(event of ["resize", "scroll", "orientationchange"]) {
        window.addEventListener(event, function() {
            iptInView(false);
        });
    }

    iptInView(true);


    /*
    **====================================================================================
    **			SCROLL TO ELEMENT
    **====================================================================================
    **/
    function getElementY(query) {
        if (document.querySelector(query)) return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top;
        else return "";
    }

    function doScrolling(element, duration) {
        let startingY = window.pageYOffset;
        const elementY = getElementY(element);
        // If element is close to page's bottom then window will scroll only to some position above the element.
        let targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY;
        let diff = targetY - startingY;
        // Easing function: easeInOutCubic
        // From: https://gist.github.com/gre/1650294
        const easing = function(t) {
            return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        }
        let start;

        if (!diff) return;

        // Bootstrap our animation - it will get called right before next frame shall be rendered.
        window.requestAnimationFrame(function step(timestamp) {
            if (!start) start = timestamp;
            // Elapsed miliseconds since start of scrolling.
            let time = timestamp - start;
            // Get percent of completion in range [0, 1].
            let percent = Math.min(time / duration, 1);
            // Apply the easing.
            // It can cause bad-looking slow frames in browser performance tool, so be careful.
            percent = easing(percent);

            window.scrollTo(0, startingY + diff * percent);

            // Proceed with animation as long as we wanted it to.
            if (time < duration) {
                window.requestAnimationFrame(step);
            }
        })
    }

    for (const elemc of document.querySelectorAll(".ipt-scroll")) {
        elemc.addEventListener('click', function(event) {
            let hrefID = elemc.getAttribute("href");
            doScrolling(hrefID, 1000);
        });
    }
    for (const elemc of document.querySelectorAll(".ipt-scroll a")) {
        elemc.addEventListener('click', function(event) {
            let hrefID = elemc.getAttribute("href");
            doScrolling(hrefID, 1000);
        });
    }
    if (window.location.hash != "") {
        doScrolling(window.location.hash, 1000);
    }


    /*
    **====================================================================================
    **		HEADER EVENTS
    **====================================================================================
    **/
    let elemHeader = document.querySelector(".jsSiteHeader");
    let elemHeaderContainer = elemHeader.querySelector(".jsSiteHeaderContainer");
    let elemHeaderStickyBase = elemHeader.querySelector(".jsSiteHeaderStickyBase");
    let isHome = false;
    let offsetToSticky = 80;

    if (document.body.classList.contains("home")) isHome = true;

    elemHeaderStickyBase.setAttribute("style", "height: " + elemHeaderContainer.offsetHeight + "px");

    //offsetToSticky = elemHeaderTopPanel.offsetHeight;

    function headerScrollEvent(scrollPos) {
        if (window.screen.width > 991) {
            if (scrollPos > offsetToSticky) {
                elemHeader.classList.add("is-stuck");
            }
            else {
                elemHeader.classList.remove("is-stuck");
            }
        }
    }

    for(event of ["resize", "orientationchange"]) {
        window.addEventListener(event, function() {
            elemHeaderStickyBase.setAttribute("style", "height: " + elemHeaderContainer.offsetHeight + "px");
            //offsetToSticky = elemHeaderTopPanel.offsetHeight;
        });
    }

    headerScrollEvent(window.scrollY);


    /*
    **====================================================================================
    **      HEADER & SUB MENU FIX
    **====================================================================================
    **/
    function fixNaviMenu() {
        document.querySelectorAll(".jsHeaderNavi .sub-menu").forEach(function(elem, index) {
            let rect = elem.getBoundingClientRect();
            let posLeftAndWidth = rect.left + rect.width;
            if (posLeftAndWidth > window.innerWidth) elem.classList.add("sub-menu--pos-fix");
        });
    }
    fixNaviMenu();

    for(event of ["resize", "scroll", "orientationchange"]) {
        window.addEventListener(event, function() {
            fixNaviMenu();
        });
    }


    /*
    **====================================================================================
    **      HEADER & SEARCHER
    **====================================================================================
    **/
    const iptSearcher = document.querySelector(".jsHeaderSearcher");
    if (iptSearcher != null) {
        const iptSearcherFormWrap = document.querySelector(".jsSearcherForm");
        const iptSearcherBtn = iptSearcher.querySelector(".jsHeaderSearcherBtn");
        let iptSearcherBtnActiveClass = "is-active";
        let iptSearcherFormWrapShowClass = "is-show";
        if (iptSearcherBtn != null) {
            iptSearcherBtn.addEventListener("click", function(event) {
                iptSearcherBtn.classList.toggle(iptSearcherBtnActiveClass);
                iptSearcherFormWrap.classList.toggle(iptSearcherFormWrapShowClass);
            });
        }
        const iptSearcherFullBtnClose = document.querySelector(".jsSearcherFullCloseBtn");
        if (iptSearcherFullBtnClose != null) {
            iptSearcherFullBtnClose.addEventListener("click", function(event) {
                iptSearcherBtn.classList.remove(iptSearcherBtnActiveClass);
                iptSearcherFormWrap.classList.remove(iptSearcherFormWrapShowClass);
            });
        }
    }


    /*
    **====================================================================================
    **		SCROLL EVENTS
    **====================================================================================
    **/
    let scrollPosition = 0;
    let ticking = false;

    document.addEventListener('scroll', function(e) {
        scrollPosition = window.scrollY;

        if (!ticking) {
            window.requestAnimationFrame(function() {
                headerScrollEvent(scrollPosition);
                ticking = false;
            });
            ticking = true;
        }
    });



    /*
    **====================================================================================
    **			PARALLAXATOR
    **====================================================================================
    **/
    let iptParallaxElemArray = [];
    iptParallaxElemArray.push({
        property: "background-position-y",
        speed: 72,
        imagesize: {
            desktop: {
                w: 1903,
                h: 366
            },
            tablet: {
                w: 800,
                h: 314
            },
            mobile: {
                w: 480,
                h: 314
            }
        },
        elem: document.querySelector(".c-subpage-title")
    });

    iptParallaxElemArray.forEach(function(thisElem, index) {
        if (thisElem.elem) {
            switch (thisElem.property) {
                case "background-position-y":
                    if (!thisElem.baseline) thisElem.baseline = 50;
                    if (!thisElem.speed) thisElem.speed = 95;
                    let baseLine = window.innerHeight - thisElem.baseline;

                    thisElem.initialBackPosY = thisElem.elem.getBoundingClientRect().top + window.scrollY;
                    if (thisElem.initialBackPosY >= baseLine) thisElem.initialBackPosY = baseLine + thisElem.elem.offsetHeight;

                    let speed = (100 - thisElem.speed) / 5;
                    if (speed < 0 || speed > 100) speed = 10;
                    else if (speed == 0) speed = 1;
                    thisElem.speed = speed;
                    thisElem.initialBackPosY = (thisElem.initialBackPosY / speed);
                    thisElem.backPosY = -1 * thisElem.initialBackPosY;

                    thisElem.imageHeight = Math.round(thisElem.initialBackPosY);
                    let imgW = 0, imgH = 0;
                    if (thisElem.imagesize) {
                        if (window.innerWidth > 800) { imgW = thisElem.imagesize.desktop.w; imgH = thisElem.imagesize.desktop.h; }
                        else if (window.innerWidth <= 800 && window.innerWidth > 480) { imgW = thisElem.imagesize.tablet.w; imgH = thisElem.imagesize.tablet.h; }
                        else if (window.innerWidth <= 480) { imgW = thisElem.imagesize.mobile.w; imgH = thisElem.imagesize.mobile.h; }

                        if (imgW != "" && imgH != "" && imgW > 0 && imgH > 0 && Number.isInteger(imgW) && Number.isInteger(imgH)) {
                            let sectionWidth = Math.round(imgW * (thisElem.elem.offsetHeight + thisElem.imageHeight) / imgH);
                            if (sectionWidth < thisElem.elem.offsetWidth) {
                                thisElem.imageHeight = (Math.round(thisElem.elem.offsetWidth * (thisElem.elem.offsetHeight + thisElem.imageHeight) / sectionWidth) - thisElem.elem.offsetHeight);
                                if (thisElem.imageHeight < 0) thisElem.imageHeight *= -1;
                            }
                        }
                    }

                    thisElem.elem.setAttribute("style", "background-position: center " + Math.round(thisElem.backPosY) + "px; background-size: auto calc(100% + " + Math.round(thisElem.imageHeight) + "px);");
                    break;
            }
        }
    });

    function iptParallaxInView() {
        iptParallaxElemArray.forEach(function(thisElem, index) {
            if (thisElem.elem && (!thisElem.minWidth || window.innerWidth >= thisElem.minWidth)) {

                let parallaxElement = thisElem.elem;
                let elementOffsetFromTop = Math.round(parallaxElement.getBoundingClientRect().top + window.scrollY);
                let elementOffsetFromBottom = Math.round(elementOffsetFromTop + parallaxElement.offsetHeight);
                let viewportScrollTop = Math.round(window.scrollY);
                thisElem.offset = (thisElem.offset != undefined) ? thisElem.offset : 0;
                let viewportScrollBottom = Math.round(viewportScrollTop + window.innerHeight - thisElem.offset);

                if (elementOffsetFromBottom > viewportScrollTop && elementOffsetFromTop < viewportScrollBottom) {
                    let opacityVal;
                    let posX;
                    let posY;

                    switch (thisElem.property) {
                        case "background-position-y":
                            if (parallaxElement) {
                                if (!thisElem.baseline) thisElem.baseline = 50;
                                let baseLine = window.innerHeight - thisElem.baseline;
                                if (parallaxElement.getBoundingClientRect().top <= baseLine && parallaxElement.getBoundingClientRect().top > (-1*parallaxElement.offsetHeight)) {

                                    if ((thisElem.elem.getBoundingClientRect().top + window.scrollY) < baseLine) {
                                        baseLine = thisElem.elem.getBoundingClientRect().top + window.scrollY;
                                    }

                                    thisElem.backPosY = baseLine - parallaxElement.getBoundingClientRect().top;

                                    if (!thisElem.initialBackPosY && thisElem.initialBackPosY != 0) thisElem.initialBackPosY = 200;
                                    thisElem.backPosY = thisElem.backPosY / thisElem.speed - thisElem.initialBackPosY;
                                }
                                parallaxElement.setAttribute("style", "background-position: center " + Math.round(thisElem.backPosY) + "px; background-size: auto calc(100% + " + thisElem.imageHeight + "px);");
                            }
                            break;
                        case "background-position-x":
                            posX = Math.round((window.scrollY - elementOffsetFromTop) / thisElem.speed);
                            parallaxElement.setAttribute("style", "background-position:  " + posX + "px center;");
                            break;
                        case "opacity-out":
                            if (thisElem.target) {
                                if (!thisElem.offset) thisElem.offset = 0;
                                posY = parallaxElement.getBoundingClientRect().top + thisElem.offset;
                                opacityVal = 1 + (posY / 1000) * 1;
                                thisElem.target.style.opacity = opacityVal;
                            }
                            break;
                        case "opacity-in":
                            if (thisElem.target) {
                                if (!thisElem.offset) thisElem.offset = 0;
                                posY = parallaxElement.getBoundingClientRect().top + thisElem.offset;
                                opacityVal = 1 - (posY / 1000) * 1;
                                thisElem.target.style.opacity = opacityVal;
                            }
                            break;
                        case "move-x-left":
                            if (thisElem.target) {
                                thisElem.speed = (thisElem.speed >= 100) ? 99 : thisElem.speed;
                                let speed = 50 - thisElem.speed;
                                speed = 50 + speed;
                                speed = (speed < 0) ? 0 : speed;
                                if (!thisElem.offset) thisElem.offset = 0;
                                posX = parallaxElement.getBoundingClientRect().top + thisElem.offset;
                                posX = Math.round(posX / speed);
                                thisElem.target.style.transform = "translateX(" + posX + "px)";
                            }
                            break;
                        case "move-y-up-down":
                            if (thisElem.target) {
                                let speed = thisElem.speed - 100;
                                speed = (speed < 0) ? (-1*speed)/10 : speed/10;
                                if (!thisElem.offset) thisElem.offset = 0;
                                posY = parallaxElement.getBoundingClientRect().top + thisElem.offset;
                                posY = Math.round((posY * -1) / speed);

                                thisElem.target.style.transform = "translateY(" + posY + "px)";

                                if (thisElem.opacityOut) {
                                    opacityVal = 1 + ((parallaxElement.getBoundingClientRect().top + thisElem.offset) / 1000) * 1;
                                    thisElem.target.style.opacity = opacityVal;
                                }
                            }
                            break;
                        case "move-y-up-down-hero":
                            if (thisElem.target) {
                                let speed = thisElem.speed - 100;
                                speed = (speed < 0) ? (-1*speed)/10 : speed/10;
                                if (!thisElem.offset) thisElem.offset = 0;

                                let offsetElemFromTop = -1*(parallaxElement.getBoundingClientRect().top + window.scrollY);
                                posY = parallaxElement.getBoundingClientRect().top + offsetElemFromTop;
                                posY = Math.round((posY * -1) / speed);
                                thisElem.target.style.transform = "translateY(" + posY + "px)";

                                if (thisElem.opacityOut) {
                                    opacityVal = 1 + ((parallaxElement.getBoundingClientRect().top + thisElem.offset) / 5000) * 1;
                                    if (opacityVal > 1) opacityVal = 1;
                                    thisElem.target.style.opacity = opacityVal;
                                }
                            }
                            break;
                        case "move-y-down-fromtop":
                            if (thisElem.target) {

                                if (parallaxElement.getBoundingClientRect().top > -500) {

                                    thisElem.posY = window.scrollY;

                                    let speed = 100 - thisElem.speed;
                                    if (speed < 0 || speed > 100) speed = 10;
                                    thisElem.posY = thisElem.posY / speed;
                                    if (thisElem.posY < 0) thisElem.posY = 0;
                                }
                                if (thisElem.posY) thisElem.target.setAttribute("style", "transform: translateY(" + Math.round(thisElem.posY) + "px)");
                            }
                            break;
                        case "move-y-down":
                            if (thisElem.target) {
                                if (!thisElem.baseline) thisElem.baseline = 200;
                                let baseLine = window.innerHeight - thisElem.baseline;

                                if (parallaxElement.getBoundingClientRect().top <= baseLine && parallaxElement.getBoundingClientRect().top > -500) {

                                    thisElem.posY = baseLine - parallaxElement.getBoundingClientRect().top;

                                    let speed = 100 - thisElem.speed;
                                    if (speed < 0 || speed > 100) speed = 10;
                                    thisElem.posY = thisElem.posY / speed;
                                    if (thisElem.posY < 0) thisElem.posY = 0;
                                }
                                if (thisElem.posY) thisElem.target.setAttribute("style", "transform: translateY(" + Math.round(thisElem.posY) + "px)");
                            }
                            break;
                        case "move-y-up":
                            if (thisElem.target) {
                                if (!thisElem.baseline) thisElem.baseline = 200;
                                let baseLine = window.innerHeight - 200;
                                if (parallaxElement.getBoundingClientRect().top <= baseLine && parallaxElement.getBoundingClientRect().top > -500) {
                                    thisElem.posY = baseLine - parallaxElement.getBoundingClientRect().top;
                                    let speed = 100 - thisElem.speed;
                                    if (speed < 0 || speed > 100) speed = 10;
                                    thisElem.posY = thisElem.posY / speed;
                                    if (thisElem.posY > 0) thisElem.posY *= -1;
                                }
                                if (thisElem.posY) thisElem.target.setAttribute("style", "transform: translateY(" + Math.round(thisElem.posY) + "px)");
                            }
                            break;
                    }
                }
            }
        });
    }

    for(event of ["resize", "scroll", "orientationchange"]) {
        window.addEventListener(event, function() {
            window.requestAnimationFrame(iptParallaxInView);
        });
    }

    const iptParallaxTimeOut = setTimeout(function() {
        iptParallaxInView();
    }, 500);


    /*
    **====================================================================================
    **		SWIPER TESTIMONIALS
    **====================================================================================
    **/
    let swiperTesti = new Swiper('.jsTestiList',{
        init: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        loop: true, //muszą być minimum 4 slajdy
        direction: 'horizontal',
        slidesPerView: 3,
        //centeredSlides: false,
        //centeredSlidesBounds: true,
        spaceBetween: 20,
        //touchEventsTarget: 'container',
        initialSlide: 0,
        //enabled: false,
        speed: 1500,
        navigation: {
            nextEl: '.jsTestiListBtnNext',
            prevEl: '.jsTestiListBtnPrev',
        },
        pagination: {
            el: ".jsTestiListSwiperPagination",
            clickable: true,
        },
        breakpoints: {
            901: {
                slidesPerView: 3
            },
            735: {
                slidesPerView: 2
            },
            100: {
                slidesPerView: 1
            }
        }
    });

});